import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";
import "./styles/text.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store/configureStore";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GlobalLoaderProvider } from "contexts/GlobalLoaderContext";
import { GlobalModalProvider } from "contexts/GlobalModalContext";
import { GlobalSelectedBranchProvider } from "contexts/GlobalSelectedBranchContext";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(/*#__PURE__*/ _jsx(Provider, {
    store: store,
    children: /*#__PURE__*/ _jsx(BrowserRouter, {
        children: /*#__PURE__*/ _jsx(GoogleOAuthProvider, {
            clientId: "224450368848-n18vttkv84nf51a7hknmd22ph48s5mjq.apps.googleusercontent.com",
            children: /*#__PURE__*/ _jsx(GlobalLoaderProvider, {
                children: /*#__PURE__*/ _jsx(GlobalModalProvider, {
                    children: /*#__PURE__*/ _jsx(GlobalSelectedBranchProvider, {
                        children: /*#__PURE__*/ _jsx(App, {})
                    })
                })
            })
        })
    })
}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
